/* ==========================================================================
   WARMBELT CO — REFINE LAYER  (v1.3)
   Bug fixes + premium behaviour. Vanilla, no deps, defensive everywhere.
   Runs last, never assumes another script succeeded.

   v1.3 — removed the non-passive wheel handler added in v1.2. Forcing every
   wheel event over a rail through JS (preventDefault + window.scrollBy) made
   the browser wait on script for each event; on the product page, which has
   80+ images and a dozen animated sections, that was enough to stall the
   renderer. The real cause of the original scroll trap was a card creating a
   scroll container, and that is fixed properly in CSS with `overflow: clip`.
   ========================================================================== */
(function () {
  "use strict";

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var doc = document;

  function ready(fn) {
    if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", fn, { once: true });
    else fn();
  }

  /* ------------------------------------------------------------------
     1 · SKIP LINK — keyboard users can jump past the hero.
  ------------------------------------------------------------------ */
  function skipLink() {
    if (doc.querySelector(".wb-skip")) return;
    var target = doc.querySelector("main") || doc.querySelector("[id^='shopify-section']");
    if (!target) return;
    if (!target.id) target.id = "wb-main";
    var a = doc.createElement("a");
    a.className = "wb-skip";
    a.href = "#" + target.id;
    a.textContent = "Skip to content";
    doc.body.insertBefore(a, doc.body.firstChild);
  }

  /* ------------------------------------------------------------------
     2 · BUG — DUPLICATE <h1>
     Keep the first, demote the rest to <h2>, preserving every attribute
     and child node. Search engines want exactly one per page.
  ------------------------------------------------------------------ */
  function oneH1() {
    var h1s = doc.querySelectorAll("h1");
    if (h1s.length < 2) return;
    for (var i = 1; i < h1s.length; i++) {
      var old = h1s[i];
      var h2 = doc.createElement("h2");
      for (var a = 0; a < old.attributes.length; a++) {
        h2.setAttribute(old.attributes[a].name, old.attributes[a].value);
      }
      while (old.firstChild) h2.appendChild(old.firstChild);
      old.parentNode.replaceChild(h2, old);
    }
  }

  /* ------------------------------------------------------------------
     3 · IMAGE HYGIENE
     - alt text inferred from the card's own caption where meaningful,
       explicit alt="" for decoration so screen readers skip it.
     - lazy + async decode below the fold, eager for the first screen.
     - fade-in ONLY for images near the first screen. Applying it to a
       lazy image that never enters the viewport would leave it stuck at
       opacity 0 forever, because the load event never fires.
     Rects are read in one batch before any writes, to avoid thrash.
  ------------------------------------------------------------------ */
  function images() {
    var imgs = Array.prototype.slice.call(doc.images), vh = innerHeight;
    var tops = imgs.map(function (i) { return i.getBoundingClientRect().top; });  // read

    imgs.forEach(function (img, idx) {                                            // then write
      if (!img.hasAttribute("alt")) {
        var card = img.closest("figure, .lcard, .mcard, .scard, [class*='card'], [class*='panel']");
        var label = "";
        if (card) {
          var cap = card.querySelector("figcaption, .cap, .ltitle, .mtitle, h2, h3, h4");
          if (cap) label = cap.textContent.trim().replace(/\s+/g, " ").slice(0, 110);
        }
        img.alt = label || "";
      }
      if (!img.hasAttribute("decoding")) img.decoding = "async";

      var nearFold = tops[idx] <= vh * 1.4;
      if (!img.hasAttribute("loading")) img.loading = nearFold ? "eager" : "lazy";

      if (!reduce && nearFold && !img.complete) {
        img.setAttribute("data-wb-fade", "");
        var done = function () { img.classList.add("wb-loaded"); };
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
        setTimeout(done, 4000);   // failsafe: never leave an image invisible
      }
    });
  }

  /* ------------------------------------------------------------------
     4 · BUG — HORIZONTAL RAILS TRAPPED THE SCROLL WHEEL
     A rail declared overflow:auto on both axes, and its cards used
     overflow:hidden with content taller than the box — which Chrome
     still treats as a scroll container, so a vertical wheel died inside
     the card instead of bubbling to the page.

     The fix lives in CSS (rail: overflow-y hidden; cards: overflow clip).
     This pass only re-applies it to rails the theme editor adds later.
     No wheel listener: intercepting the gesture in JS costs a
     non-passive handler on every scroll event and is not needed.
  ------------------------------------------------------------------ */
  function rails() {
    var list = doc.querySelectorAll(".rail, [data-rail], .hscroll, .lrail, .mrail");
    Array.prototype.forEach.call(list, function (r) {
      r.style.overflowY = "hidden";
      r.style.overscrollBehaviorX = "contain";
    });
    var cards = doc.querySelectorAll(".lcard, .mcard, .scard, .life-card, .material-card, .showcase-card");
    Array.prototype.forEach.call(cards, function (c) { c.style.overflow = "clip"; });
  }

  /* ------------------------------------------------------------------
     5 · BACK TO TOP
  ------------------------------------------------------------------ */
  function backToTop() {
    if (doc.querySelector(".wb-top")) return;
    var b = doc.createElement("button");
    b.className = "wb-top";
    b.type = "button";
    b.setAttribute("aria-label", "Back to top");
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener("click", function () {
      scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    });
    doc.body.appendChild(b);

    /* Lift it above the sticky buy bar via a body class rather than a CSS
       :has() rule — :has() with `body` as its subject forces a whole-document
       style invalidation on every inline-transform write, and these pages
       write dozens of those per animation frame. That locks the renderer. */
    if (doc.querySelector(".sticky-atc")) doc.body.classList.add("wb-has-bar");

    var on = false, ticking = false;
    function check() {
      var should = (scrollY || pageYOffset) > innerHeight * 0.9;
      if (should !== on) { on = should; b.classList.toggle("is-on", on); }
      ticking = false;
    }
    addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    check();
  }

  /* ------------------------------------------------------------------
     6 · PERF — flag background tabs so animation work can be suppressed.
  ------------------------------------------------------------------ */
  function pauseWhenHidden() {
    function sync() { doc.documentElement.classList.toggle("wb-paused", doc.hidden); }
    doc.addEventListener("visibilitychange", sync);
    sync();
  }

  /* ------------------------------------------------------------------
     7 · INSTANT NAVIGATION — prefetch an internal page on hover/touch
     intent. Same-origin only, capped, idle-scheduled, never cart/checkout.
  ------------------------------------------------------------------ */
  function prefetch() {
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ""))) return;

    var seen = Object.create(null), count = 0, MAX = 12;
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 120); };

    function grab(url) {
      if (count >= MAX || seen[url]) return;
      seen[url] = 1; count++;
      idle(function () {
        var l = doc.createElement("link");
        l.rel = "prefetch"; l.href = url; l.as = "document";
        doc.head.appendChild(l);
      });
    }

    function candidate(e) {
      var a = e.target && e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (_) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname) return;
      if (/\/(cart|checkout|account)/.test(u.pathname)) return;
      if (a.hasAttribute("download") || a.target === "_blank") return;
      grab(u.pathname + u.search);
    }

    doc.addEventListener("mouseover", candidate, { passive: true });
    doc.addEventListener("touchstart", candidate, { passive: true });
  }

  /* ------------------------------------------------------------------
     8 · ACCORDION a11y — the markup uses <button> but never reported
     state, so screen readers announced nothing.
  ------------------------------------------------------------------ */
  function accordions() {
    var qs = doc.querySelectorAll(".acc-q, .faq-q");
    Array.prototype.forEach.call(qs, function (q) {
      if (q.dataset.wbAcc) return;
      q.dataset.wbAcc = "1";
      function sync() {
        q.setAttribute("aria-expanded", q.classList.contains("is-open") ? "true" : "false");
      }
      sync();
      q.addEventListener("click", function () { setTimeout(sync, 0); });
    });
  }

  /* ------------------------------------------------------------------
     9 · EXTERNAL LINKS — rel hygiene (security + SEO).
  ------------------------------------------------------------------ */
  function externals() {
    var as = doc.querySelectorAll('a[target="_blank"]');
    Array.prototype.forEach.call(as, function (a) {
      var rel = (a.getAttribute("rel") || "").split(/\s+/).filter(Boolean);
      if (rel.indexOf("noopener") < 0) rel.push("noopener");
      if (rel.indexOf("noreferrer") < 0) rel.push("noreferrer");
      a.setAttribute("rel", rel.join(" "));
    });
  }

  /* ---------------------------- init ---------------------------- */
  ready(function () {
    try { skipLink(); } catch (e) {}
    try { oneH1(); } catch (e) {}
    try { images(); } catch (e) {}
    try { rails(); } catch (e) {}
    try { backToTop(); } catch (e) {}
    try { pauseWhenHidden(); } catch (e) {}
    try { accordions(); } catch (e) {}
    try { externals(); } catch (e) {}
    try { prefetch(); } catch (e) {}
  });

  // Sections re-render in the theme editor — re-run the DOM passes.
  doc.addEventListener("shopify:section:load", function () {
    try { images(); rails(); accordions(); externals(); } catch (e) {}
  });
})();
